import { IFeature } from 'mod/featureV2/interface';

export const waterFall: IFeature = {
    moduleId: 'waterFall',
    type: 'waterFall',
    title: 'VGrow On Instagram',
    description: 'description',
    config: {
        height: 514,
        column: 3,
        spaceBetweenColumns: 20,
        viewMoreText: 'View More 6 >',
        pageSize: 4,
    },
    list: [
        {
            picUrl: 'https://cdn-2.jjshouse.com/upimg/jjshouse/o600/a6/7c/03f05003c6b225635a94ecff40d9a67c.jpg',
            linkUrl: '/vivosun-smart-grow-box?mock=1'
        }, {
            picUrl: 'asset/width-966/picture/8f0dd4a3f07eec80b5e764c855524d5e.jpg',
            linkUrl: '/vivosun-smart-grow-box?mock=1'
        },
        {
            picUrl: 'asset/width-3840/picture/fd86506cd62c23660cc6118d045e00af.jpg',
        },{
            picUrl: 'asset/width-966/picture/8f0dd4a3f07eec80b5e764c855524d5e.jpg',
            linkUrl: '/vivosun-smart-grow-box?mock=1'
        },
        {
            picUrl: 'asset/width-3840/picture/fd86506cd62c23660cc6118d045e00af.jpg',
        },
        {
            picUrl: 'asset/width-3840/picture/fd86506cd62c23660cc6118d045e00af.jpg',
        },
        {
            picUrl: 'asset/width-3840/picture/fd86506cd62c23660cc6118d045e00af.jpg',
            linkUrl: '/vivosun-smart-grow-box?mock=1'
        },
        {
            picUrl: 'asset/width-3840/picture/fd86506cd62c23660cc6118d045e00af.jpg',
        },{
            picUrl: 'asset/width-966/picture/8f0dd4a3f07eec80b5e764c855524d5e.jpg',
            linkUrl: '/vivosun-smart-grow-box?mock=1'
        },
        {
            videoUrl: 'file-asset/file/62205f7a09e5dc4661cdcd6640e32305/1703665032125/output.m3u8',
            picUrl: 'asset/width-3840/picture/fd86506cd62c23660cc6118d045e00af.jpg',
        },
        {
            picUrl: 'asset/width-3840/picture/fd86506cd62c23660cc6118d045e00af.jpg',
            linkUrl: '/vivosun-smart-grow-box?mock=1'
        },
        {
            picUrl: 'asset/width-3840/picture/fd86506cd62c23660cc6118d045e00af.jpg',
        },{
            picUrl: 'asset/width-966/picture/8f0dd4a3f07eec80b5e764c855524d5e.jpg',
            linkUrl: '/vivosun-smart-grow-box?mock=1'
        },
        {
            picUrl: 'asset/width-966/picture/8f0dd4a3f07eec80b5e764c855524d5e.jpg',
            linkUrl: '/vivosun-smart-grow-box?mock=1'
        },
    ]
};